import { gql } from "@apollo/client";

export const STATIC_DOCUMENTS = gql`
  query StaticDocuments(
    $where: StaticDocumentWhereInput
    $take: Int
    $skip: Int
  ) {
    staticDocuments(where: $where, take: $take, skip: $skip) {
      data {
        id
        name
        type
        versions
        updatedDate
        attachment {
          id
          name
        }
        usages {
          id
          ignoreOthers
          exactMatch
          steps
          insurancePlans {
            id
            name
          }
        }
      }
      count
    }
  }
`;

export const STATIC_DOCUMENT = gql`
  query StaticDocument($where: StaticDocumentWhereInput) {
    staticDocument(where: $where) {
      id
      name
      type
      versions
      attachment {
        id
        name
      }
      usages {
        id
        ignoreOthers
        exactMatch
        steps
        insurancePlans {
          id
          name
        }
      }
    }
  }
`;

export const STATIC_DOCUMENT_FILE = gql`
  query StaticDocumentFile($where: StaticDocumentWhereInput!, $version: ID) {
    staticDocumentFile(where: $where, version: $version)
  }
`;

export const STATIC_ATTACHMENTS = gql`
  query StaticAttachments(
    $where: ProjectWhereInput!
    $insurancePlans: [InsurancePlanWhereInput!]!
    $upsells: [InsurancePlanWhereInput!]
    $step: String
  ) {
    staticAttachments(
      where: $where
      insurancePlans: $insurancePlans
      upsells: $upsells
      step: $step
    ) {
      id
      identifier
      name
      key
      filename
      fileUrl
      contentType
      type
      createdDate
    }
  }
`;

const staticDocuments = {
  STATIC_DOCUMENTS,
  STATIC_DOCUMENT,
  STATIC_DOCUMENT_FILE,
  STATIC_ATTACHMENTS,
};

export default staticDocuments;
